module.exports = __webpack_public_path__ + "static/img/bg_3.7c0e098.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_3.jpg
// module id = mL/j
// module chunks = 1